export type ConsoleUiLang = 'fr' | 'en';

/** Accept only `fr` | `en` (case-insensitive, trimmed); else null. */
export function normalizeConsoleUiLang(
  raw: string | null | undefined
): ConsoleUiLang | null {
  if (raw == null) return null;
  const trimmed = String(raw).trim().toLowerCase();
  if (trimmed === 'fr' || trimmed === 'en') return trimmed;
  return null;
}

/**
 * Console locale entry path for a User Language.
 * Production nginx serves localized builds under `/fr` and `/en`
 * (Angular EN `baseHref` is `/en/`; FR is the source locale).
 */
export function consoleLocaleHref(
  lang: ConsoleUiLang,
  pathname: string = '/'
): string {
  const rest = pathname.replace(/^\/(fr|en)(?=\/|$)/, '') || '/';
  const prefix = lang === 'en' ? '/en' : '/fr';
  if (rest === '/') {
    return `${prefix}/`;
  }
  return `${prefix}${rest.startsWith('/') ? rest : `/${rest}`}`;
}
